import type { GenieNodeState } from '@genieartinc/schemas'

/** Older documents have no provenance. Preserve any existing name; never guess from its text. */
export function modelTitleState(state: Record<string, unknown>, modelName: string): Pick<GenieNodeState, 'title' | 'titleSource' | 'modelName'> {
  const title = typeof state.title === 'string' ? state.title : ''
  const titleSource = state.titleSource === 'automatic' || (!title && state.titleSource !== 'custom')
    ? 'automatic' : 'custom'
  return { title: titleSource === 'automatic' ? modelName : title, titleSource, modelName }
}
